import { Fragment, lazy } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { animated, useTransition } from "react-spring";
import AboutProject from "Views/AboutProject";
import AboutTeam from "Views/AboutTeam";
import ArchiveSixth from "Views/archive/ArchiveSixth";
import ArchiveFifth from "Views/archive/ArchiveFifth";
import ArchiveFirst from "Views/archive/ArchiveFirst";
import ArchiveFourth from "Views/archive/ArchiveFourth";
import ArchiveSecond from "Views/archive/ArchiveSecond";
import ArchiveThird from "Views/archive/ArchiveThird";
import Characters from "Views/Characters";
import HistoryOfMikolajow from "Views/HistoryOfMikolajow";
import Start from "Views/Start";
import Intro from "../Views/Intro";
import Player from "../Views/Player";
const MyScene = lazy(() => import("../Views/MyScene"));

export const Router = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
  returnLink,
  tutorialPage,
  setTutorialPage,
}) => {
  const location = useLocation();

  const transitions = useTransition(location, {
    key: location,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    config: { duration: 1000 },
    exitBeforeEnter: true,
  });
  return (
    <Fragment>
      {transitions((props, item) => {
        let importantOpacity;
        if (item.pathname === "/scene") {
          importantOpacity = { opacity: 1 };
        }
        return (
          <animated.div style={{ ...props, ...importantOpacity }}>
            <Routes location={location}>
              <Route
                path="/"
                element={
                  <Start
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/intro"
                element={
                  <Intro
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/player/:id"
                element={
                  <Player
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/scene"
                element={
                  <MyScene
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                    returnLink={returnLink}
                    tutorialPage={tutorialPage}
                    setTutorialPage={setTutorialPage}
                  />
                }
              />
              <Route
                path="/wyjazd-na-odpust-w-sulislawicach"
                element={
                  <ArchiveFirst
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/dziecinstwo-w-mikolajowie"
                element={
                  <ArchiveSecond
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/kopalnia-wspolczesnie"
                element={
                  <ArchiveThird
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/moment-wysiedlenia-mikolajow"
                element={
                  <ArchiveFourth
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/kiedys-dzis-1"
                element={
                  <ArchiveFifth
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/kiedys-dzis-2"
                element={
                  <ArchiveSixth
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />

              <Route
                path="/o-projekcie"
                element={
                  <AboutProject
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/historia-mikolajowa"
                element={
                  <HistoryOfMikolajow
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/zespol"
                element={
                  <AboutTeam
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/bohaterowie"
                element={
                  <Characters
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
            </Routes>
          </animated.div>
        );
      })}
    </Fragment>
  );
};
